<template>
    <div :class="classObj" class="app-wrapper">
        <div v-if="device === 'mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
        <div class="layout-header">
            <navbar />
            <tags-view v-if="needTagsView" />
        </div>
        <alert-banner v-if="hasAlertBanner" />
        <div class="layout-body">
            <Sidebar class="sidebar-container" />
            <div :class="{ hasTagsView: needTagsView }" class="main-container">
                <app-main />
                <right-panel v-if="showSettings">
                    <settings />
                </right-panel>
            </div>
        </div>
    </div>
</template>

<script>
import RightPanel from "@/components/RightPanel";
import { AlertBanner, AppMain, Navbar, Settings, Sidebar, TagsView } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
import { mapState } from "vuex";

export default {
    name: "Layout",
    components: {
        AlertBanner,
        AppMain,
        Navbar,
        RightPanel,
        Settings,
        Sidebar,
        TagsView,
    },
    mixins: [ResizeMixin],
    computed: {
        ...mapState({
            sidebar: (state) => state.app.sidebar,
            device: (state) => state.app.device,
            showSettings: (state) => state.settings.showSettings,
            needTagsView: (state) => state.settings.tagsView,
            hasAlertBanner: (state) => state.boundaryAlarm.activeCount > 0,
        }),
        classObj() {
            return {
                hideSidebar: !this.sidebar.opened,
                openSidebar: this.sidebar.opened,
                withoutAnimation: this.sidebar.withoutAnimation,
                mobile: this.device === "mobile",
            };
        },
    },
    methods: {
        // 越界告警横幅的数据源现在是全局 WebSocket（/websocket/global，code===3）推送的，
        // 见 src/App.vue 的 globalWs()，这里不用再轮询接口
        handleClickOutside() {
            this.$store.dispatch("app/closeSideBar", { withoutAnimation: false });
        },
    },
};
</script>

<style lang="scss" scoped>
// #f0f2f5
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-wrapper {
    @include clearfix;
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100%;
    overflow: hidden;

    &.mobile.openSidebar {
        position: fixed;
        top: 0;
    }
}

.drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
}

.layout-header {
    flex-shrink: 0;
    position: relative;
    z-index: 10;
}
</style>
